import styles from './FilterChips.module.css';

export interface FilterOption<K> {
  key: K;
  label: string;
  count: number;
}

/** A row of quick filters as pill buttons with counts; exactly one is on. */
export function FilterChips<K extends string | null>({
  label,
  options,
  value,
  onChange,
  testId,
}: {
  /** The group's accessible name. */
  label: string;
  options: readonly FilterOption<K>[];
  value: K;
  onChange: (key: K) => void;
  testId?: string;
}) {
  return (
    <div className={styles.filters} role="group" aria-label={label} data-testid={testId}>
      {options.map((o) => {
        const on = o.key === value;
        return (
          <button
            key={o.key ?? 'all'}
            type="button"
            className={on ? `${styles.filter} ${styles.filterOn}` : styles.filter}
            aria-pressed={on}
            onClick={() => onChange(o.key)}
          >
            {o.label} <span className={styles.filterCount}>{o.count}</span>
          </button>
        );
      })}
    </div>
  );
}
